export const NARRATIVE_COMMUNITY_LIST_PAGE_SIZE = 9;
export const NARRATIVE_COMMUNITY_CURSOR_QUERY_PARAM = 'cursor';
